const name = "兴文石海";

export default {
    // 解密aesKey
    aesKey: "uwTZwrCZYh7zKROK",

    // 测试环境
    // baseUrl: "https://ggfw.smarttourisms.com/api/",
    // authUrl: "https://ggfw.smarttourisms.com/auth/user/",
    // app_id: "qoUVUKVpIAHnqULxAOjv", // 项目标识
    // publicPath: "", // 资源前缀
    // name: name, // 项目名称
    // decrypt: true, // 是否加密
    // showBannerTitle: true, // 是否显示bannerTitle

    // 相如故城
    // baseUrl: "https://ggfw.smarttourisms.com/api/",
    // authUrl: "https://ggfw.smarttourisms.com/auth/user/",
    // app_id: "qoUVUKVpIAHnqULxAOjv",
    // publicPath: "",
    // name: name,
    // decrypt: true,
    // showBannerTitle: true,

    // 兴文石海
    baseUrl: process.env.NODE_ENV == "development" ? '/api' : "https://xhshgw.xwshtxq.com/api",
    authUrl: process.env.NODE_ENV == "development" ? '/auth/user' : "https://xhshgw.xwshtxq.com/auth/user",
    app_id: "VpzLBbXwzCHCszCDkkSz",
    publicPath: "",
    name: name,
    decrypt: true,
    showBannerTitle: true,

    // 兴文僰王山
    // baseUrl: "https://bwsgw.xwshtxq.com/api",
    // authUrl: "https://bwsgw.xwshtxq.com/auth/user",
    // app_id: "ZJUnHAHQgDAdUOiCnCzF",
    // publicPath: "",
    // name: name,
    // decrypt: true,
    // showBannerTitle: true,

    // 察尔汗
    // baseUrl: "https://www.mhyhly.com/api",
    // authUrl: "https://www.mhyhly.com/auth/user/",
    // app_id: "qoUVUKVpIAHnqULxAOjv",
    // publicPath: "",
    // name: name,
    // decrypt: true,
    // showBannerTitle: false,

    // 高坪
    // baseUrl: "https://www.gpwldsj.com/api",
    // authUrl: "https://www.gpwldsj.com/user/",
    // app_id: "yvLxdgHPykvZsUIvVqIS",
    // publicPath: "",
    // name: name,
    // decrypt: true,
    // showBannerTitle: true,

    // 玉龙拉措
    // baseUrl: "https://www.yulonglacuo.cn/api",
    // authUrl: "https://www.yulonglacuo.cn/auth/user",
    // app_id: "qoUVUKVpIAHnqULxAOjv",
    // publicPath: "",
    // name: name,
    // decrypt: true,
    // showBannerTitle: true,

    // 阿暑达
    // 本地
    // baseUrl: process.env.NODE_ENV == "development" ? "http://192.168.20.160:9413" : "/api",
    // authUrl: process.env.NODE_ENV == "development" ? "http://192.168.20.160:9200/auth/user" : "/user",
    // 线上 admin f8WhGya7xCssthSd
    // baseUrl: process.env.NODE_ENV == "development" ? "https://www.asdsjhh.com/api" : "/api",
    // authUrl: process.env.NODE_ENV == "development" ? "https://www.asdsjhh.com/auth/user" : "/user",
    // app_id: "qoUVUKVpIAHnqULxAOjv",
    // publicPath: "",
    // name: name,
    // decrypt: true,
    // showBannerTitle: true,

    // 大瓦山
    // baseUrl: process.env.NODE_ENV == "development" ? "https://www.dawashan.cc/api" : "/api",
    // authUrl: process.env.NODE_ENV == "development" ? "https://www.dawashan.cc/auth/user" : "/user",
    // app_id: "qoUVUKVpIAHnqULxAOjv",
    // publicPath: "",
    // name: name,
    // decrypt: true,
    // showBannerTitle: true,

    // 李庄古镇  李庄古镇屏蔽了在线投诉请知晓
    //  src\views\TravelGuide\Index.vue这个里面屏蔽的
    // 线上 lzadmin f8WhGya7xCssthSd1
    // baseUrl: process.env.NODE_ENV == "development" ? "https://lzgz.lzdjq.com/api" : "/api",
    // authUrl: process.env.NODE_ENV == "development" ? "https://lzgz.lzdjq.com/auth/user" : "/user",
    // app_id: "qoUVUKVpIAHnqULxAOjv",
    // publicPath: "",
    // name: name,
    // decrypt: true,
    // showBannerTitle: true,

    nav: [
        { title: "首页", route: "/", type: 0 },
        { title: `初识${name}`, route: "/general", type: 0 },
        { title: `感知${name}`, route: "/media", type: 0 },
        { title: `智游${name}`, route: "/resource", type: 0 },
        { title: "旅游资讯", route: "/news", type: 0 },
        { title: "旅游活动", route: "/activity", type: 0 },
        { title: "旅游指南", route: "/travelguide", type: 0 },
        // { title: "个人中心", route: "/mine", type: 0 }
    ],

    footer: [
        {
            name: `初识景区`,
            path: "/general",
            list: [
                // 这里动态渲染
            ],
        },
        {
            name: `感知景区`,
            path: "/media",
            list: [
                { name: "美景图库", path: "/media/image" },
                { name: "精彩视频", path: "/media/video" },
                { name: "虚拟体验", path: "/media/video?type=liveAction" },
                { name: "旅游攻略", path: "/media/strategy" },
                { name: "旅游路线", path: "/media/line" },
                { name: "景区手绘", path: "/media/gis" },
            ],
        },
        {
            name: `智游景区`,
            path: "",
            list: [
                { name: "热门景点", path: "/list?type=SPOT" },
                { name: "特色美食", path: "/list?type=FOOD" },
                { name: "酒店住宿", path: "/list?type=HOTEL" },
                { name: "旅游特产", path: "/list?type=SPECIALTY" },
                { name: "休闲娱乐", path: "/list?type=RECREATION" },
            ],
        },
        {
            name: "旅游资讯",
            path: "/news",
            list: [
                // 这里动态渲染
            ],
        },
        {
            name: "旅游活动",
            path: "/activity",
            list: [],
        },
        {
            name: "旅游指南",
            path: "/travelguide",
            list: [
                { name: "天气查询", path: "/travelguide/weather" },
                // { name: "在线投诉", path: "/travelguide/complaint" },
                { name: "出行指南", path: "/travelguide/trip" },
            ],
        },
        // {
        //     name: "个人中心", path: "/mine" ,
        //     list: [
        //         { name: "注册", path: "/login" },
        //         { name: "登陆", path: "/login" },
        //         { name: "个人资料", path: "/mine" },
        //         { name: "安全设置", path: "" },
        //     ]
        // }
    ],

    // 分页
    paging: {
        page: 1,
        limit: 9,
    },
};
